module.exports = __webpack_public_path__ + "img/reward-subtitle01.27165bcb.png";